<div class="layout-default">    
    <div style="background-color: #1E88E5; flex: 1;"></div>
    <pm-thumb [ItemOrientation]="'Horizontal'"
              [Mode]="'Basis'"
              [ElementLocation]="'Next'"
              [ElementFlexBasis]="Column1">
    </pm-thumb>
    <div #Column1 style="background-color: #ff5252; flex-basis: 35%;"></div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-9.html